// extracted by mini-css-extract-plugin
module.exports = {"banner":"reviews-module--banner--34YA2","smaller":"reviews-module--smaller--1Fvxc","more":"reviews-module--more--LNGCF","btn":"reviews-module--btn--36p0E"};